// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1f8QS","head":"Table_head__3aWkp","col":"Table_col__38b6A"};